import { makeStyles } from 'tss-react/mui'

export const useStyles = makeStyles()(theme => ({
  tabelWrapper: {
    display: 'flex',
    minWidth: theme.spacing(83),
    padding: theme.spacing(3, 5, 3, 5),
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: theme.spacing(5),
    borderRadius: theme.spacing(1),
    background: theme.palette.common.white,
    boxSizing: 'border-box',
  },
  root: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(3),
    backgroundColor: theme.palette.common.white,
    margin: theme.spacing(-4),
    padding: theme.spacing(4, 0),
  },
}))
